import React from 'react'

import AirportDropdownOption from './AirportDropdownOption'

export const SEARCH_MENU_LIST_ITEM_CLASS_NAME = 'search-menu-list-item'

interface Props {
  airport: App.AirportLocation
  onClick?: (searchItem: App.AirportLocation, mouseEvent?: React.MouseEvent<HTMLElement>) => void
  ['data-testid']?: string
}

function FlightAirportFieldListOption(props: Props) {
  const {
    airport,
    onClick,
  } = props

  return (
    <AirportDropdownOption
      key={airport.id}
      subRecord={airport.isCityAirport}
      airport={airport}
      onSelectAirport={onClick}
    />
  )
}

export default FlightAirportFieldListOption
